import {createApp} from 'vue'
import App from './App.vue'
import './assets/index.css'
import {router} from './routeur.js'
import {createPinia} from "pinia";
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
import {library} from '@fortawesome/fontawesome-svg-core'
import {
    faBars,
    faCheck,
    faChevronDown,
    faChevronUp,
    faCircleExclamation,
    faCodeMerge,
    faCubes,
    faDownload,
    faEdit,
    faEquals,
    faEuroSign,
    faForward,
    faHammer,
    faHome,
    faMinus,
    faPause,
    faPlay,
    faPlus,
    faPowerOff,
    faSquare,
    faSquareMinus,
    faSquarePlus,
    faTimes,
    faToolbox,
    faTrash,
    faTriangleExclamation
} from "@fortawesome/free-solid-svg-icons";
import {faCreativeCommonsNcEu} from "@fortawesome/free-brands-svg-icons";
import './registerServiceWorker'

const pinia = createPinia();

library.add(faTimes, faCheck, faSquarePlus, faSquareMinus, faBars, faEdit, faTrash,
    faPlus, faMinus, faEquals, faCircleExclamation, faTriangleExclamation, faChevronDown, faChevronUp,
    faEuroSign, faCreativeCommonsNcEu, faHome, faPause, faSquare, faPlay, faCodeMerge, faPowerOff, faHammer, faToolbox,
    faDownload, faCubes, faForward);

createApp(App)
    .use(router)
    .use(pinia)
    .component('font-awesome-icon', FontAwesomeIcon)
    .mount('#app')
